<template>
  <div
    v-if="!isLoading2"
    class="section"
  >
    <div class="columns is-centered">
      <div class="column is-11">
        <div class="columns">
          <div class="column has-text-centered">
            <h2 class="title is-2">
              Submit Statements
            </h2>
            <div class="subtitle is-2">
              Your filing requirement is not satisfied until you agree with the eletronic signature statement below. Submitted statements can not be edited, a new amendment statement must be submitted.
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="certify-component">
              <div class="section">
                <checkbox-adv
                  id="electronicSignature"
                  ref="electronicSignature"
                  v-model="electronicSignature"
                  rules="required"
                  :options="options"
                />
                <div
                  v-if="currentFiling"
                  class="forms-list"
                >
                  <br>
                  <template v-if="currentFiling.stateForm === 'Y'">
                    <p><strong>State Form:</strong> Public Official and Employee Ethics Act, 65 Pa.C.S. §1109(b).</p>
                  </template>
                  <template v-if="currentFiling.cityForm === 'Y'">
                    <p><strong>City Form:</strong> Sections 20-610(2) and 20-612 of The Philadelphia Code</p>
                  </template>
                  <template v-if="currentFiling.mayorForm === 'Y'">
                    <p><strong>Mayor's Form:</strong> Mayor's Executive Order No. 11-84, as amended</p>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column has-text-centered">
            <button
              id="submit-btn"
              type="button"
              class="button is-primary"
              :class="isSaving ? 'is-loading' : ''"
              :disabled="isSaving"
              @click="saveAndSubmitCheck"
            >
              Submit Statement(s)
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { filerScreenHelpers } from '@/mixins/filerScreen';
import { pdfData } from '@/mixins/pdfData';
import { withValidation } from 'vee-validate';
import { Checkbox } from '@phila/phila-ui';
// import CheckboxAdv from '@/components/phila-ui/CheckboxAdv';

const CheckboxAdv = withValidation(Checkbox);

export default {
  name: "SubmitStatements",
  components: {
    CheckboxAdv,
  },
  mixins: [
    filerScreenHelpers,
    pdfData,
  ],
  data() {
    return {
      ready: false,
      currentFiling: null,
      electronicSignature: [],
      isSaving: false,
      options: {
        agreed: 'By checking this box I hereby certify and affirm that the foregoing information is true and correct to the best of my knowledge, information and belief; said affirmation being made subject to the penalties prescribed by 18 Pa.C.S. §4904 (unsworn falsification to authorities) and the following:',
      },
    };
  },
  computed: {},
  async created () {
    await this.initialFetch();
    await this.initalAssign();
    this.$store.commit('loading', false);
  },

  methods: {
    async initialFetch () {
      let promises = [];
      return Promise.all(promises);
    },
    async initalAssign () {
      this.currentFiling = this.getCurrentFiling();
    },
    async saveAndSubmitCheck () {
      this.isSaving = true;
      const itemRef = this.$refs['electronicSignature'];
      const isValid = await itemRef.validate();

      if (!isValid.valid) {
        this.isSaving = false;
        return false;
      }

      this.submitStatements();

    },
    async submitStatements () {

      let filing = {
        id: this.currentFiling.id,
        amendable: 'Y',
      };

      let cityFormData = null;
      let stateFormData = null;
      let mayorFormData = null;

      if (this.currentFiling.filingStatus === 'NF') {
        filing.filingStatus = 'FI';
      }

      if (this.currentFiling.filingStatus === 'AP') {
        filing.filingStatus = 'AF';
      }

      if (this.currentFiling.mayorForm === 'Y') {
        filing.mayorReceived = 'Y';
        filing.mayoResigned = 'Y';
        mayorFormData = await this.pdf_getPdfData('Mayor');
      }

      if (this.currentFiling.cityForm === 'Y') {
        filing.cityReceived = 'Y';
        filing.cityeSigned = 'Y';
        cityFormData = await this.pdf_getPdfData('City');
      }

      if (this.currentFiling.stateForm === 'Y') {
        filing.stateReceived = 'Y';
        filing.stateeSigned = 'Y';
        stateFormData = await this.pdf_getPdfData('State');
      }

      filing.completedDate = this.formatDate(null, 'YYYY-MM-DDTHH:mm:ss');

      this.$store.dispatch('filing/saveFiling', filing).then(() => {
        let pdfPromises = [];
        if (cityFormData) {
          pdfPromises.push(this.$store.dispatch('filing/getPdf', cityFormData));
        }
        if (stateFormData) {
          pdfPromises.push(this.$store.dispatch('filing/getPdf', stateFormData));
        }
        if (mayorFormData) {
          pdfPromises.push(this.$store.dispatch('filing/getPdf', mayorFormData));
        }

        Promise.all(pdfPromises).then(() => {
          this.$router.push({ name: this.nextFilingScreen });
          this.isSaving = false;
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  .forms-list {
    padding: 5px 20px;
    line-height: 1.5rem;
  }
</style>
